export class CreateSoilUseCase {
  constructor(repository) {
    this.repository = repository
  }
  async execute(soil) {

    const resp = await this.repository.save(soil)

    return resp
  }
}
